import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * CreateServiceTicket Input Action
 */
export class CreateServiceTicketInput implements Msdyn365.IActionInput {
    public serviceTicket: ICreateServiceTicket;
    constructor(serviceTicket: ICreateServiceTicket) {
        this.serviceTicket = serviceTicket;
    }

    public getCacheKey = () => `CreateServiceTicketKey`;
    public getCacheObjectType = () => 'CreateServiceTicket';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface ICreateServiceTicketData {
    text: string;
}

export interface ICreateServiceTicket {
    AssetId: string;
    CustomerId: string;
    TypeCode: string;
    StatusCode: string;
    Priority: string;
    CreationDate: string;
    Title: string;
    Description: string;
    SubjectId: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CreateServiceTicketInput({} as ICreateServiceTicket);
};

async function action(input: CreateServiceTicketInput, ctx: Msdyn365.IActionContext): Promise<ICreateServiceTicketData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const requestBody = { serviceTicket: input.serviceTicket, language: ctx.requestContext.locale };

    const response = await Msdyn365.sendRequest<ICreateServiceTicketData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/CreateServiceTicket`,
        'post',
        requestBody,
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICreateServiceTicketData>>action,
    id: 'CreateServiceTicket',
    input: createInput
});
